export default "__VITE_ASSET__Ds$xN6HR__"